import React from "react";
import { BRAND } from "../lib/brand";

export default function CtaBanner() {
  return (
    <section data-testid="cta-banner" className="relative bg-[color:var(--dbe-red)] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage:
          "repeating-linear-gradient(-45deg, rgba(255,255,255,0.25) 0 2px, transparent 2px 18px)",
      }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 py-14 md:py-20 flex flex-col md:flex-row items-center md:items-center justify-between gap-6 md:gap-8">
        <div className="text-center md:text-left">
          <div className="text-[10px] sm:text-xs tracking-[0.3em] uppercase opacity-80">Don't wait until it's worse.</div>
          <h2 className="mt-2 font-bebas text-4xl sm:text-5xl md:text-6xl leading-[1.02] md:leading-none tracking-wide">
            Call us today.<br className="sm:hidden" /> Sleep better tonight.
          </h2>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          <a
            href={`tel:${BRAND.phoneTel}`}
            data-testid="cta-banner-call"
            className="inline-flex items-center justify-center gap-3 bg-white text-[color:var(--dbe-red)] hover:bg-[color:var(--dbe-cream)] px-6 sm:px-7 py-3.5 sm:py-4 rounded-full font-bebas text-xl sm:text-2xl tracking-wide"
          >
            <i className="fa-solid fa-phone" /> {BRAND.phoneDisplay}
          </a>
          <a
            href="#quote"
            data-testid="cta-banner-quote"
            className="inline-flex items-center justify-center gap-2 bg-black/30 hover:bg-black/50 border border-white/30 text-white px-6 sm:px-7 py-3.5 sm:py-4 rounded-full font-bold uppercase tracking-wider text-xs sm:text-sm"
          >
            Free Estimate <i className="fa-solid fa-arrow-right text-xs" />
          </a>
        </div>
      </div>
    </section>
  );
}
